<p-toast position="top-center"/>
<p-table #dt [first]="first" [value]="tableData" dataKey="id" [rows]="rowsPerPage"
  [showCurrentPageReport]="true" [showJumpToPageDropdown]="false" [showJumpToPageInput]="true"
  [sortMode]="sortMode" [multiSortMeta]="multiSortMeta" (onPage)="onPageChange($event)" [reorderableColumns]="true"
  [rowsPerPageOptions]="rowsPerPageOptions" [paginator]="isPaginationEnabled" [paginatorPosition]="paginatorPosition"
  editMode="row" class="prime-table" [class.boxed-container]="isBoxedTable" [showGridlines]="false"
  loadingIcon="pi pi-spin pi-spinner" [loading]="false" [rowHover]="true" [globalFilterFields]="columnNames"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries {{filterPaginationText}}"
  (onSort)="tableSorted($event)" (onFilter)="filterApplied($event)" [sortField]="sortField" [sortOrder]="sortOrder">
  @if (showCaptionPanel) {
    <ng-template pTemplate="caption">
      <div class="headerbox">
        <ng-content select=".header-container"></ng-content>
        <button pButton label="Reset Filters" [raised]="true" (click)="clearTable()" icon="pi pi-filter-slash"
          severity="secondary" class="reset-all-btn" [class.filter-highlight]="filterPaginationText !== ''">
        </button>
        @if (showGlobalFilter) {
          <span class="p-input-icon-left ml-auto">
            <i class="pi pi-search me-2"></i>
            <input pInputText #globalfilter type="text" (input)="applyGlobalFilter($event, 'contains')"
              placeholder="Search any column" />
          </span>
        }
      </div>
    </ng-template>
  }
  <ng-template pTemplate="header">
    <tr class="p-selectable-row">
      @for (column of columnList; track column) {
        <th [pSortableColumnDisabled]="isEditMode || column.disableSort || !sortableTable" [class]="column.colSize" [id]="column.name"
          [pSortableColumn]="column.sortField ?? column.name" [style.width.%]="column.widthPercent ?? (100 / columnList.length)">
          <div class="div-table-column-header">
            {{column.label}}
            @if (hasActiveFilter(column)) {
              <span class="filter-active-dot" aria-hidden="true"></span>
            }
            @if (columnFilterDisplay === 'menu' && !column.hideFilter) {
              <ng-container *ngTemplateOutlet="columnFilterTemplate context: {column}"></ng-container>
            }
            @if (!column.disableSort && !isEditMode && sortableTable) {
              <p-sortIcon field="{{column.sortField ?? column.name}}" (click)="isColumnSorted = true"
                (keyup.enter)="isColumnSorted = true" (keyup.space)="isColumnSorted = true">
              </p-sortIcon>
            }
          </div>
        </th>
      }
      @if (editableTable) {
        <th id="editHeaderCell"></th>
      }
    </tr>
    @if (columnFilterDisplay === 'row' && showFilters) {
      <tr [class.disable-form]="isEditMode">
        @for (column of columnList; track column) {
          <th [class]="column.colSize" class="th-filter" id="{{column.name}}_filter">
            @if (!column.hideFilter) {
              <div class="th-filter-div" [class.active-filter]="hasActiveFilter(column)">
                @if (column.type === 'date' || column.type === 'numeric') {
                  <span class="condition" [style.font-weight]="hasActiveFilter(column) ? 700 : 400">
                    {{ matchModeStringMappings[columnFilters[column.filterField ?? column.name]?.filter?.matchMode ?? column.matchMode] }}
                  </span>
                }
                <ng-container *ngTemplateOutlet="columnFilterTemplate context: {column}"></ng-container>
              </div>
            }
          </th>
        }
        @if (editableTable) {
          <th id="editHeaderFilterCell"></th>
        }
      </tr>
    }
  </ng-template>
  <ng-template #columnFilterTemplate let-column="column">
    <p-columnFilter #columnFilter [type]="column.type" field="{{column.filterField ?? column.name}}"
      [display]="columnFilterDisplay" filterOn="input" [maxFractionDigits]="column.maxFractionDigits ?? 2" [class]="column.type"
      [showAddButton]="column.type !== 'category'" [showMenu]="column.type !== 'category' || columnFilterDisplay === 'menu'"
      [showMatchModes]="column.type !== 'category'" [matchMode]="column.matchMode" [matchModeOptions]="column.matchModeOptions"
      (onShow)="columnFilterShow(column, columnFilter)" placeholder="Search" [useGrouping]="false" [showButtons]="false"
      [showOperator]="columnFilters[column.filterField ?? column.name]?.filters?.length > 1">
      @if (column.type === 'date') {
        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
          <p-datepicker panelStyleClass="prime-datepicker" [readonlyInput]="column.matchMode === 'dateRange'"
            [(ngModel)]="column.filterDates" iconDisplay="input" showButtonBar="true" appendTo="body"
            [dateFormat]="column.calendarFormat" [showTime]="!column.dateOnly" (onClear)="filter(null)" (onClearClick)="filter(null)"
            (onSelect)="filter(column.filterDates)" [selectionMode]="column.dateSelectionMode" placeholder="Select">
          </p-datepicker>
        </ng-template>
      }
      @else if (column.type === 'category') {
        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
          <p-multiselect display="chip" selectedItemsLabel="{0} items" [ngModel]="value" placeholder="Select"
            [options]="uniqueDataArray[column.name]" (onChange)="filter($event.value)" appendTo="body">
          </p-multiselect>
        </ng-template>
      }
    </p-columnFilter>
    @if (column.type !== 'category' && hasActiveFilter(column)) {
      <button pButton type="button" icon="pi pi-times" text rounded size="small" class="filter-clear-btn"
        (click)="clearColumnFilter(column, columnFilter)" aria-label="Clear column filter">
      </button>
    }
  </ng-template>
  <ng-template pTemplate="body" let-entry let-rowEditing="editing" let-rowIndex="rowIndex">
    <tr [pEditableRow]="entry" [class.row-clickable]="rowClickable && !isEditMode" [class.row-unsaved]="entry.unsaved"
      (click)="onRowClick(entry)" (keyup.enter)="onRowClick(entry)" (keyup.space)="onRowClick(entry)">
      @for (column of columnList; track column) {
        <td [style.width.%]="column.widthPercent ?? (100 / columnList.length)" [class]="column.colSize"
          [class.sorted-column]="dt.sortField === (column.sortField ?? column.name) || multiSortData[column.sortField ?? column.name]">
          @if (column.inputType && editableTable) {
            <p-cellEditor id="cellEditor">
              <ng-template pTemplate="input">
                @if (column.inputType === 'numeric') {
                  <p-inputnumber [showButtons]="true" buttonLayout="stacked" [min]="column.minValue" [max]="column.maxValue"
                    (onChange)="onInputChange($event, entry, column)" [(ngModel)]="entry[column.name]"
                    [maxFractionDigits]="column.isInteger ? 0 : column.maxFractionDigits ?? 2" fluid />
                }
                @else if (column.inputType === 'select') {
                  <p-select [(ngModel)]="entry[column.name]" appendTo="body" (onChange)="onInputChange($event, entry, column)"
                    [options]="column.inputSelectOptions" [placeholder]="column.inputPlaceholder" 
                    [optionValue]="column.name" [optionLabel]="column.displayField ?? column.name">
                  </p-select>
                }
                @else if (column.inputType === 'multiselect') {
                  <p-multiselect display="chip" [(ngModel)]="entry[column.name]" selectedItemsLabel="{0} items"
                    [options]="column.inputSelectOptions" [placeholder]="column.inputPlaceholder"
                    [optionValue]="column.name" [optionLabel]="column.displayField ?? column.name" appendTo="body">
                  </p-multiselect>
                }
                @else if (column.inputType === 'date') {
                  <p-datepicker [(ngModel)]="entry[column.name]" [dateFormat]="column.calendarFormat"
                    [showTime]="!column.dateOnly" appendTo="body" fluid>
                  </p-datepicker>
                }
                @else if (column.inputType === 'template') {
                  <ng-container *ngTemplateOutlet="column.editTemplate; context: {entry}"></ng-container>
                }
                @else {
                  <input pInputText type="text" [(ngModel)]="entry[column.name]" (onChange)="onInputChange($event, entry, column)"
                    [placeholder]="column.inputPlaceholder" fluid />
                }
              </ng-template>
              <ng-template pTemplate="output">
                <ng-container *ngTemplateOutlet="cellTemplate context: {column, entry}"></ng-container>
              </ng-template>
            </p-cellEditor>
          }
          @else {
            <ng-container *ngTemplateOutlet="cellTemplate context: {column, entry}"></ng-container>
          }
        </td>
      }
      @if (editableTable) {
        <td>
          <div class="flex items-center justify-center gap-2">
            @if (rowEditing) {
              <button pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                (click)="onRowEditSave(entry)" text rounded severity="secondary">
              </button>
              <button pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                (click)="onRowEditCancel(entry)" text rounded severity="secondary">
              </button>
            }
            @else {
              <button pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                (click)="onRowEditInit(entry)" text rounded severity="secondary" [disabled]="isEditMode">
              </button>
              @if (showDeleteButton) {
                <button pButton pRipple type="button" icon="pi pi-trash" 
                  (click)="onRowDelete(entry)" text rounded severity="danger" [disabled]="isEditMode">
                </button>
              }
            }
          </div>
        </td>
      }
    </tr>
  </ng-template>
  <ng-template #cellTemplate let-entry="entry" let-column="column">
    <div class="td-content">
      @if (column.type === 'date' && entry[column.name] !== '-') {
        {{ entry[column.name] | date: column.dateFormat }}
      }
      @else if (column.currency) {
        {{ entry[column.name] | currency: column.currency:'symbol':'1.2-2' }}
      }
      @else if (column.type === 'numeric') {
        {{ entry[column.name] | number }}
      }
      @else if (column.type === 'button') {
        <button pButton label="{{column.name}}" (click)="buttonClicked(entry, column.name)"></button>
      }
      @else if (column.link) {
        <a [href]="entry[column.link]" target="_blank">{{entry[column.name]}}</a>
      }
      @else if (column.showIcon) {
        <div class="icon-container" [style.justify-content]="column.iconAlignment ?? 'left'">
          @for (icon of entry[column.name].icons; track icon) {
            @if (icon.glyph) {
              <span class="icon-glyph" [title]="icon.title" [attr.aria-label]="icon.label ?? icon.title" role="img">
                {{ icon.glyph }}
              </span>
            }
            @if (icon.imageUrl) {
              <img [src]="icon.imageUrl" [title]="icon.title" alt="{{icon.title}}">
            }
            @if (icon.primeClass) {
              <button pButton icon="pi {{icon.primeClass}}" (click)="buttonClicked(entry, icon.action)"
                [severity]="icon.severity ?? 'info'" [title]="icon.title" rounded outlined></button>
            }
          }
        </div>
      }
      @else {
        {{ entry[column.displayField ?? column.name] }}
      }
    </div>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td class="td-emptymessage" rowspan="10" [attr.colspan]="columnList?.length">
        @if (loading) {
          Loading Table Data
        }
        @else {
          No Entries Found
          @if (filterPaginationText) {
            on Filters Applied
          }
        }
      </td>
    </tr>
  </ng-template>
</p-table>